// Apolo IDE — MermaidBlockBody (sprint plan-tab-v1, E3).
//
// V1: source viewer + botão "Abrir no Mermaid Live". Rendering inline
// chega numa sprint futura (precisa de mermaid lib ou worker SVG).

import { useState } from 'react';
import { ExternalLink, GitBranch } from 'lucide-react';

const MERMAID_LIVE_BASE = 'https://mermaid.live/edit#pako:';

function toMermaidLiveUrl(source) {
  // Mermaid Live uses pako-zipped base64. Pra v1 mandamos via fragment encoded.
  // Fallback: open editor empty with source in clipboard — keep it simple.
  try {
    const payload = { code: source, mermaid: { theme: 'dark' } };
    const json = JSON.stringify(payload);
    // base64url (no padding, url-safe)
    const b64 = btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return `https://mermaid.live/edit#base64:${b64}`;
  } catch {
    return MERMAID_LIVE_BASE;
  }
}

export default function MermaidBlockBody({ payload, onChange, accent }) {
  const [source, setSource] = useState(payload.source || '');
  function commit() { onChange({ ...payload, source }); }
  const liveUrl = toMermaidLiveUrl(source);
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex items-center gap-2 border-b border-apolo-borderSubtle/60 px-3 py-1.5 text-[10px] uppercase tracking-wide" style={{ color: accent }}>
        <GitBranch size={11} aria-hidden="true" />
        <span>Diagrama Mermaid</span>
        <a
          href={liveUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-auto inline-flex items-center gap-1 rounded px-2 py-0.5 text-[10px] font-medium text-apolo-textSecondary hover:bg-apolo-surface2 hover:text-apolo-textPrimary"
          aria-label="Abrir no Mermaid Live"
        >
          <ExternalLink size={10} /> Editar online
        </a>
      </div>
      <textarea
        value={source}
        onChange={(e) => setSource(e.target.value)}
        onBlur={commit}
        spellCheck={false}
        className="flex-1 resize-none border-0 bg-transparent p-3 font-mono text-[11px] leading-relaxed text-apolo-textPrimary placeholder:text-apolo-textPlaceholder focus:outline-none"
        placeholder="graph TD;&#10;  A-->B;&#10;  A-->C;&#10;  B-->D;"
      />
    </div>
  );
}
